import { PrintRequest } from './../carrier/print-request';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../carrier/response-container';
import { timeout, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Covid19Batch } from '../agptesting-newview/model/covid19Batch'
import { ShipToSenderDTO } from './ship-To-Sender';
import { WorkFlow } from '../masterdata/models/workFlow';
import { Falcon } from '../models/depoolingRetestDTO';


@Injectable()
export class APGAdministrationService {
  defaultTimeout = 600000;

  constructor(private http: HttpClient) {
  }

  redoBatchService(batch: Covid19Batch): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/redo";
    return this.http.put<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  changeBatchStatus(batch: Covid19Batch, noOfPositivePCRControls: number, noOfNegativePCRControls: number): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/status?noOfPositivePCRControls="+noOfPositivePCRControls+"&noOfNegativePCRControls="+noOfNegativePCRControls;
     return this.http.put<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
       error.url = url;
     }));
  }

  getBatchForLabAndBatchId(labId: string, batchId: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch";
    let requestParam = new HttpParams().set('lab', labId).set('batchID', batchId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  fetchSampleInfo(selectedLabId: string, searchID: string): Observable<BBResponseContainer>  {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/sample/search/" + selectedLabId + "/" + searchID;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
  }

  fetchSampleAllBatchInfo(selectedLabId: string, searchID: string): Observable<any>  {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/sample/searchHistoryBatches/" + selectedLabId + "/" + searchID;
    return this.http.get<any>(url).pipe(timeout(environment.defaultTimeout));
  }
  
  deleteSampleFromBatch(selectedLabId: string, sampleBarcode: string, batchIdToDeleteSample: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/sample/remove?lab=" + selectedLabId + '&sampleBarcode=' + sampleBarcode;
    if(batchIdToDeleteSample)
      url = url + "&batchId=" + batchIdToDeleteSample;
    return this.http.put<BBResponseContainer>(url, '').pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  removeBatch(labId: string, labName: string, batchId: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/remove/" + labId + '/' + labName + '/' + batchId;
    return this.http.put<BBResponseContainer>(url,'').pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  changeFalseRedo(labId: string, covidBatch: Covid19Batch, redoCount: number) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/falseredo/" + labId + '/' + redoCount;
    return this.http.put<BBResponseContainer>(url, covidBatch).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  removeUnnecessaryRedo(labId: string, selectedBatchIdToComplete: string, batchIdsTobeRemoved: string[]) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/unnecessaryredo/" + labId + '/' + selectedBatchIdToComplete;
    return this.http.put<BBResponseContainer>(url, batchIdsTobeRemoved).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  shipToSender(shipToSenderDTO :ShipToSenderDTO) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/shipToBarcode";
    return this.http.post(url,shipToSenderDTO ).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
      }, error => {
      error.url = url;
    }));
  }

  searchPreperationPool(labId: string, id: string, searchBy: string): Observable<BBResponseContainer>{
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19-pool/search/"+labId;
    let requestParam = new HttpParams().set("id", id).set("searchBy", searchBy);
    const options = url ? {params: requestParam} : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  searchChaotincPool(labId: string, id: string, ): Observable<BBResponseContainer>{ 
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "chaoticPool/search/"+id; 
    let requestParam = new HttpParams().set("labId", labId);
     const options = url ? {params: requestParam} : {};
     return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
   }

  updateWorkFlow(workFlow:WorkFlow,labId:string,batchId:string){
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'covid19Batch/updateWorkflow/'+labId+'/'+batchId;
    return this.http.put<BBResponseContainer>(url, workFlow).pipe(timeout(this.defaultTimeout));
  }

  updateRedoSample(labId: string, batchId: string, barcode:string, sender,rush: boolean): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/redosample/" + labId + "/" + batchId + "/" + barcode + "/" + sender + "/" + rush;
    return this.http.put<BBResponseContainer>(url, null).pipe(timeout(environment.defaultTimeout));
  }

  editExistingFalcon(labId: string, boxID: string, falconID: string, unwrappedSample: Falcon){
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "lollipooling/updateFalcon/"+falconID+"?labId="+labId+"&boxID="+boxID;
    return this.http.put<Falcon>(url, unwrappedSample).pipe(timeout(environment.defaultTimeout));
  }
}
